import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../../../../helpers/masks";
import { useMemo, useState } from "react";
import DialogCadastrarRecb, { IInternForm } from "./DialogCadastrarRecb";
import EditNoteIcon from '@mui/icons-material/EditNote';
import DialogFormRecb from "./DialogFormRecb";
import DialogPix from "../../../../../../../../../../components/BasicComponents/Pagamentos/DialogPix";
import { PesquisarTitulosAReceber } from "../../../../Step01";

export default function Recebimento() {

    const { watch, getValues, setValue } = useFormContext();

    const { selecionar_titulos } = getValues()

    const valueRecb: IInternForm[] = watch('finalizacao.recebimentos')

    const [openModal, setOpenModal] = useState<IOpenModal>({
        state: false,
        preValue: null
    })
    const [openFormEspecifico, setOpenFormEspecifico] = useState(false);
    const [itemParaEditar, setItemParaEditar] = useState<IInternForm | null>(null);
    const [indexEditar, setIndexEditar] = useState<number | null>(null);

    //funções manipuladoras
    const handleOpenModal = (value: number | null = null) => {
        setOpenModal({
            state: true,
            preValue: value
        })
    }

    const handleCloseModal = () => {
        setOpenModal({
            state: false,
            preValue: null
        })
    }

    const handleRemoveItem = (index: number) => {
        const valoresRecb = getValues('finalizacao.recebimentos')
        valoresRecb.splice(index, 1);
        setValue('finalizacao.recebimentos', valoresRecb)
    }

    const handleOpenFormEspecifico = (item: any) => {
        setItemParaEditar(item);
        setOpenFormEspecifico(true);
    }

    const handleCloseFormEspecifico = () => {
        setOpenFormEspecifico(false);
        setItemParaEditar(null);
        setIndexEditar(null);
    }

    const handlePixPago = () => {
        if (itemParaEditar && indexEditar !== null) {
            const valoresRecb = getValues('finalizacao.recebimentos');
            const updatedItem = {
                ...itemParaEditar,
                pix_pago: true,
            };
            const updatedRecb = [...valoresRecb];
            updatedRecb[indexEditar] = updatedItem;
            setValue('finalizacao.recebimentos', updatedRecb);
            handleCloseFormEspecifico();
        }
    }
    //

    //valores importantes
    const valorTotal = useMemo(() => valueRecb.reduce((acumulador: number, item: any) =>
        acumulador + formatarMonetárioParaNúmero(item.valor), 0
    ), [valueRecb])
    //

    return (
        <Box mt={2}>
            {
                (valueRecb.length <= 0) && (
                    <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        justifyContent="center"
                        borderRadius={1}
                        height={200}
                        border="1px solid #1B5E20"
                        gap={0.5}
                    >
                        <Typography variant="subtitle2">Clique no botão abaixo para adicionar os valores recebidos</Typography>
                        <Typography variant="caption" mb={1}>(Ex: Dinheiro, PIX, Cartão de Crédito, etc..)</Typography>
                        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenModal()}>
                            Adicionar
                        </Button>
                    </Box>
                )
            }

            {
                (valueRecb.length > 0) &&
                <>
                    <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6">Valores</Typography>

                        <Button size="small" variant="contained" startIcon={<EditIcon />} onClick={() => handleOpenModal(null)}>
                            Editar
                        </Button>
                    </Box>

                    <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Forma de recebimento</b></TableCell>
                                    <TableCell align="right"><b>Valor</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {
                                    valueRecb.map((item: any, index: number) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {item.formaPagamento?.label ?? "-"}<br />
                                                    {item.nsu ? `NSU: ${item.nsu} - ` : ""}{item.autorizacao ? `Autorizacao: ${item.autorizacao}` : ""}
                                                </TableCell>

                                                <TableCell align="right">
                                                    {item.valor}
                                                </TableCell>

                                                <TableCell align="right">
                                                    <Box display="flex" gap={0.5} justifyContent="flex-end">
                                                        <IconButton disabled={!item.precisa_tratativa} aria-label="edit" size="small" onClick={() => {
                                                            handleOpenFormEspecifico(item);
                                                            setIndexEditar(index);
                                                        }}>
                                                            <EditNoteIcon fontSize="inherit" />
                                                        </IconButton>

                                                        <IconButton aria-label="delete" size="small" color="error" onClick={() => handleRemoveItem(index)}>
                                                            <DeleteIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }

                                <TableRow
                                    sx={{
                                        bgcolor: "#E8E8E8",
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        <b>Valor total</b>
                                    </TableCell>

                                    <TableCell
                                        colSpan={2}
                                        align="right"
                                    >
                                        <b>{formatarValorMonetario(valorTotal)}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }

            {
                openModal.state &&
                <DialogCadastrarRecb
                    open={openModal.state}
                    value={openModal.preValue}
                    handleClose={() => handleCloseModal()}
                />
            }
            {
                openFormEspecifico && !itemParaEditar?.formaPagamento?.requerModalPix && indexEditar !== null &&
                <DialogFormRecb
                    open={openFormEspecifico}
                    item={itemParaEditar}
                    index={indexEditar}
                    handleClose={handleCloseFormEspecifico}
                />
            }
            {
                openFormEspecifico && itemParaEditar?.precisa_tratativa && itemParaEditar?.formaPagamento?.requerModalPix &&
                <DialogPix
                    open={openFormEspecifico}
                    routes={{
                        route: '/financeiro/contas-receber/emitir-pix',
                        routeParams: {
                            ...{
                                titulos: selecionar_titulos.map((i: PesquisarTitulosAReceber) => i.id),
                                loja_id: getValues("finalizacao.loja").id,
                                valor_receber: formatarMonetárioParaNúmero(String(itemParaEditar?.valor)),
                                forma_recebimento_id: itemParaEditar?.formaPagamento?.id,
                                varios_recebimentos: true,
                            }
                        },
                        aguardandoPagamentoRoute: '/financeiro/contas-receber/consultar-emissao-pix/',
                    }}
                    onClose={handleCloseFormEspecifico}
                    onSuccess={() => {
                        handlePixPago();
                    }}
                    tipo_publico={selecionar_titulos[0]?.tipo_publico}
                    codigo_publico={selecionar_titulos[0]?.codigo_publico}
                />
            }
        </Box>
    )
}

interface IOpenModal {
    state: boolean,
    preValue: number | null
}